import { useState } from "react";
import { AlertCircle } from "lucide-react";

import { Modal, ModalBody } from "@/modules/common/components";
import { ImportTariffsError } from "@/service/response/admin-aneel-tariffs";

interface ImportErrorsModalProps {
  errors?: ImportTariffsError[] | null;
}

const ImportErrorsModal = ({ errors }: ImportErrorsModalProps) => {
  const [open, setOpen] = useState(false);

  if (!errors?.length) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-medium text-red-600 hover:underline"
      >
        <AlertCircle className="h-3.5 w-3.5 shrink-0" />
        Ver erros ({errors.length})
      </button>

      <Modal
        open={open}
        onOpenChange={setOpen}
        title="Erros da importação"
        description="Erros identificados durante o processamento do arquivo."
      >
        <ModalBody className="gap-2 max-h-[60vh] overflow-y-auto">
          {errors.map((error, index) => (
            <div key={index} className="rounded-lg bg-red-50 p-3 text-sm text-red-700">
              {error.message}
            </div>
          ))}
        </ModalBody>
      </Modal>
    </>
  );
};

export default ImportErrorsModal;
